export interface WorkflowNotificationListDivider {
  label: string;
  type: string;
  disabled: boolean;
  value: string;
}

export const variablesDivider: Readonly<WorkflowNotificationListDivider> = {
  label: 'Variables',
  type: 'divider',
  disabled: true,
  value: 'variables-divider',
};

export const usersDivider: Readonly<WorkflowNotificationListDivider> = {
  label: 'Users',
  type: 'divider',
  disabled: true,
  value: 'users-divider',
};

export const WorkflowNotificationListDividers = [variablesDivider, usersDivider] as const;
